import { twMerge } from 'tailwind-merge';
import { FaCheck, FaTriangleExclamation } from 'react-icons/fa6';

/* Small radio dot used on tiles and lists. */
export function Radio({ on }) {
	return (
		<span
			className={twMerge(
				'w-5 h-5 rounded-full flex-none grid place-items-center border-2 transition',
				on ? 'border-primary' : 'border-slate-300'
			)}
		>
			{on && <span className="w-2.5 h-2.5 rounded-full bg-primary" />}
		</span>
	);
}

/* Square checkbox used when multiple items can be picked. */
export function CheckBox({ on }) {
	return (
		<span
			className={twMerge(
				'w-[22px] h-[22px] rounded-md flex-none grid place-items-center border-2 text-white transition',
				on ? 'bg-primary border-primary' : 'border-slate-300'
			)}
		>
			{on && <FaCheck size={12} />}
		</span>
	);
}

/* Large selectable tile: emoji icon box + title (+badge) + description + radio.
   Used for scope, publish-mode, voice-mode and review-gate choices. */
export default function SelectTile({ selected, onClick, emoji, iconColor = '#5A0AE0', title, desc, note, badge, className = '', disabled = false }) {
	return (
		<button
			type="button"
			onClick={disabled ? undefined : onClick}
			disabled={disabled}
			className={twMerge(
				'relative text-left bg-white rounded-2xl border-[1.5px] transition p-[18px] flex gap-[14px] items-start flex-1 min-w-[250px]',
				selected
					? 'border-primary shadow-[0_0_0_3px_rgba(90,10,224,0.12)]'
					: 'border-slate-200 hover:border-slate-300 hover:shadow-medium',
				disabled && !selected && 'opacity-50',
				disabled && 'cursor-not-allowed hover:shadow-none hover:border-slate-200',
				className
			)}
		>
			<div
				className="w-11 h-11 rounded-[13px] grid place-items-center flex-none text-[22px]"
				style={{ background: iconColor + '18' }}
			>
				<span>{emoji}</span>
			</div>
			<div className="flex-1 min-w-0 pr-6">
				<div className="text-[15px] font-semibold text-slate-800 flex items-center gap-2 flex-wrap">
					{title}
					{badge && (
						<span className="text-[11px] font-semibold px-2 py-[3px] rounded-full bg-emerald-50 text-emerald-700">{badge}</span>
					)}
				</div>
				<div className="text-[12px] text-slate-500 mt-1 leading-relaxed">{desc}</div>
				{note && (
					<div className="mt-1.5 flex items-start gap-1.5 text-[11.5px] font-medium text-amber-600 leading-relaxed">
						<FaTriangleExclamation size={12} className="mt-[2px] flex-none text-amber-500" />
						<span>{note}</span>
					</div>
				)}
			</div>
			<span className="absolute top-4 right-4"><Radio on={selected} /></span>
		</button>
	);
}
